import React from "react";

interface SectionProps {
  className?: string; 
  id?: string;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ className = "", id, children }) => {
  return (
    <section id={id} className={`py-12 ${className}`}>
      <div className="max-w-6xl mx-auto px-4">
        {children}
      </div>
    </section>
  );
};

export default Section;
